<template>
  <slot />
  <UiToastContainer />
</template>
